/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable import/prefer-default-export */
// analytics.ts
import { logEvent } from 'firebase/analytics'
import analytics from './index'

/**
 * Logs an event to Firebase Analytics.
 * @param eventName - The name of the event (e.g., "button_click").
 * @param params - Additional parameters to provide context for the event.
 */
export const logFirebaseEvent = (
  eventName: string,
  params: Record<string, any> = {}
) => {
  logEvent(analytics, eventName, params)
}
